import {
  MagnifyingGlassIcon as MagnifyingGlassOutline,
  TagIcon as TagOutline,
  DocumentArrowDownIcon as DocumentArrowDownOutline,
  UserGroupIcon as UserGroupOutline,
  BellAlertIcon as BellAlertOutline,
  ChartBarIcon as ChartBarOutline,
  CircleStackIcon as CircleStackOutline,
  Cog6ToothIcon as Cog6ToothOutline,
  LockClosedIcon as LockClosedOutline,
  DocumentTextIcon as DocumentTextOutline,
  CloudIcon as CloudOutline,
  ArrowPathIcon as ArrowPathOutline,
  SparklesIcon as SparklesOutline,
  BoltIcon as BoltOutline,
  ShieldCheckIcon as ShieldCheckOutline,
  GlobeAltIcon as GlobeAltOutline,
  CubeIcon as CubeOutline,
} from '@heroicons/react/24/outline';
import {
  MagnifyingGlassIcon as MagnifyingGlassSolid,
  TagIcon as TagSolid,
  DocumentArrowDownIcon as DocumentArrowDownSolid,
  UserGroupIcon as UserGroupSolid,
  BellAlertIcon as BellAlertSolid,
  ChartBarIcon as ChartBarSolid,
  CircleStackIcon as CircleStackSolid,
  Cog6ToothIcon as Cog6ToothSolid,
  LockClosedIcon as LockClosedSolid,
  DocumentTextIcon as DocumentTextSolid,
  CloudIcon as CloudSolid,
  ArrowPathIcon as ArrowPathSolid,
  SparklesIcon as SparklesSolid,
  BoltIcon as BoltSolid,
  ShieldCheckIcon as ShieldCheckSolid,
  GlobeAltIcon as GlobeAltSolid,
  CubeIcon as CubeSolid,
} from '@heroicons/react/24/solid';

const OUTLINE_ICON_MAP = {
  'magnifying-glass': MagnifyingGlassOutline,
  tag: TagOutline,
  'document-arrow-down': DocumentArrowDownOutline,
  'user-group': UserGroupOutline,
  'bell-alert': BellAlertOutline,
  'chart-bar': ChartBarOutline,
  'circle-stack': CircleStackOutline,
  'cog-6-tooth': Cog6ToothOutline,
  cog: Cog6ToothOutline,
  'lock-closed': LockClosedOutline,
  'document-text': DocumentTextOutline,
  cloud: CloudOutline,
  'arrow-path': ArrowPathOutline,
  sparkles: SparklesOutline,
  bolt: BoltOutline,
  'shield-check': ShieldCheckOutline,
  'globe-alt': GlobeAltOutline,
  cube: CubeOutline,
};

const SOLID_ICON_MAP = {
  'magnifying-glass': MagnifyingGlassSolid,
  tag: TagSolid,
  'document-arrow-down': DocumentArrowDownSolid,
  'user-group': UserGroupSolid,
  'bell-alert': BellAlertSolid,
  'chart-bar': ChartBarSolid,
  'circle-stack': CircleStackSolid,
  'cog-6-tooth': Cog6ToothSolid,
  cog: Cog6ToothSolid,
  'lock-closed': LockClosedSolid,
  'document-text': DocumentTextSolid,
  cloud: CloudSolid,
  'arrow-path': ArrowPathSolid,
  sparkles: SparklesSolid,
  bolt: BoltSolid,
  'shield-check': ShieldCheckSolid,
  'globe-alt': GlobeAltSolid,
  cube: CubeSolid,
};

export function getFeatureIcon(iconName, variant = 'outline') {
  const key = String(iconName || 'sparkles').toLowerCase().trim();
  const map = variant === 'solid' ? SOLID_ICON_MAP : OUTLINE_ICON_MAP;
  return map[key] || (variant === 'solid' ? SparklesSolid : SparklesOutline);
}
